import { HttpClient } from '@/shared/lib/http-client';

export const fetchPartners = async () => {
  const response = await HttpClient.get('/partners', {});
  return response.data?.data;
};
